var r = /* @__PURE__ */ ((i) => (i.promotion = "promotion", i.article = "article", i.resource = "resource", i))(r || {}), a = /* @__PURE__ */ ((i) => (i.image = "image", i.video = "video", i.pdf = "pdf", i.audio = "audio", i))(a || {}), d = /* @__PURE__ */ ((i) => (i.Image = "image", i.Video = "video", i.PDF = "file-pdf", i.Audio = "volume", i))(d || {});
export {
  r as Contents,
  d as Icons,
  a as ResourceType
};
//# sourceMappingURL=propsTypes.js.map
